export default __webpack_public_path__ + "static/media/gordita-light.c69452f3.woff2";